
import request from '@/api/request.js';


/**
 * 查询菜单勋章
 */
export function toDoCount(data) {
    return request({
        url: 'workspace/pages/process/toDoCount',
        method: 'POST',
        data,
    });
}

export function selectAllMenu() {
    return request({
        url: 'sys/SysMenu/getAllMenu',
        method: 'POST',
    });
}